import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { BRAND } from "@/lib/brand";

const SECTIONS = [
  {
    h: "1. Engagement",
    p: "By instructing Chartwell (NZ) Ltd T/A Grafton Group (\u201cGrafton Group\u201d, \u201cwe\u201d, \u201cus\u201d) to recover an overdue account, you (\u201cthe client\u201d) engage us to act on your behalf to collect the amounts owed to you. These terms, together with our Schedule of Charges, form the basis of that engagement.",
  },
  {
    h: "2. Authority",
    p: "You authorise Grafton Group to contact the debtor, negotiate payment or payment arrangements, issue formal demands, serve documents and, where appropriate and with your instruction, commence and conduct District Court recovery proceedings on your behalf.",
  },
  {
    h: "3. Costs & commission",
    p: "Our fees are set out in the Schedule of Charges and are payable in accordance with it. Collection commission, hourly rates, disbursements and court filing costs apply as described there. Where costs are recoverable from the debtor we will pursue them, but you remain responsible for our fees and disbursements incurred on your instruction.",
  },
  {
    h: "4. Payments & remittance",
    p: "Funds recovered are received into our trust/office account and remitted to you less our fees and any agreed deductions. Payments by debtors are to be made to Chartwell (NZ) Ltd T/A Grafton Group at Westpac Banking Corporation. No statements are issued; our invoices are due on receipt.",
  },
  {
    h: "5. Information you provide",
    p: "You confirm that the debt referred is genuine, correctly stated, and legally owing, and that you will provide accurate supporting information (invoices, agreements, correspondence) on request. You will promptly advise us of any direct payments or contact from the debtor.",
  },
  {
    h: "6. Confidentiality & privacy",
    p: "We handle all information confidentially and in accordance with the Privacy Act. Debtor information is used solely for the purpose of recovering the account referred to us.",
  },
  {
    h: "7. Credit reporting",
    p: "Where an account remains unpaid, the debt may be recorded with credit reporting agencies, which may affect the debtor\u2019s credit rating. This is carried out in accordance with applicable law and industry practice.",
  },
  {
    h: "8. Termination",
    p: "Either party may end this engagement by written notice. Fees, commission and disbursements incurred up to the date of termination remain payable. Xero continues to be used for your billing.",
  },
];

export default function TermsPage() {
  return (
    <div className="light-scope min-h-screen flex flex-col">
      <Nav theme="light" />
      <div className="flex-1 max-w-[900px] mx-auto w-full px-5 md:px-10 pt-32 md:pt-40 pb-24" data-testid="terms-page">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#58635C] hover:text-[#0A0D0B] transition-colors mb-8">
          <ArrowLeft size={15} /> Back to home
        </Link>
        <span className="text-[11px] uppercase tracking-[0.3em] text-[#B89874]">Engagement</span>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight text-[#0A0D0B] mt-4 leading-[1.05]">Terms of Engagement</h1>
        <p className="mt-6 text-[#58635C] leading-relaxed max-w-[70ch]">
          These terms set out how {BRAND.legal} works with you when you refer an overdue account for recovery.
          Please read them alongside our{" "}
          <Link to="/schedule" className="text-[#B89874] underline hover:text-[#0A0D0B]">Schedule of Charges</Link>.
        </p>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <div key={s.h} className="border-l-2 border-[#E5E1D8] pl-6">
              <h2 className="font-display text-xl text-[#0A0D0B]">{s.h}</h2>
              <p className="mt-2 text-[#58635C] leading-relaxed max-w-[72ch]">{s.p}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-xs text-[#98A09A] leading-relaxed max-w-[72ch]">
          These terms are provided for the convenience of clients engaging our recovery services and do not constitute legal advice.
          For questions, contact our office on {BRAND.phone} or {BRAND.email}.
        </p>
      </div>
      <Footer />
    </div>
  );
}
